import React from 'react'
import Collapse from "../../components/Collapse";

export const Head = () => {
  return (
    <head>
      <h1 className="font-bold text-3xl text-center">Protocols</h1>
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/preparation-of-competent-bacterial-cells-docx.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/transformation-of-e-coli-by-heat-shock.pdf"
      />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/purelink-quick-plasmid-miniprep-kit.pdf"
      />
        <link
          rel="preload"
          as="document"
          href="https://static.igem.wiki/teams/5058/yeast-transformation.pdf"
        />
      <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/cell-growth-curve-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/glucose-dosage-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/phosphate-quantification.pdf  "
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/yeast-biomass-determination.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/solid-cross-feeding.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/liquid-cross-feeding-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/low-phosphate-cross-feeding-assay.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/bioreactor-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/adapted-b-galactosidase-assay.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/inoculation-of-a-thaliana-in-medium-conditioned-with-different-precursors-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/sterilizing-the-surface-of-seeds-by-chlorine-gas-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/a-thaliana-col-o-germination-test-under-drought-stress-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/a-thaliana-col-o-germination-test-under-salt-stress-docx.pdf"
      />
       <link
        rel="preload"
        as="document"
        href="https://static.igem.wiki/teams/5058/pot-experiment-with-arabidopsis-thaliana-col-0-nr-under-drought-stress-docx.pdf"
      />
     

    </head>
  );
};

const Protocols: React.FC = () =>{
    return (
<React.Fragment>
<main className="mx-auto max-w-7xl">
      <section className="mb-5">
        <Collapse.Title><h1 className="font-bold text-[#83cd9a]">DOWNLOAD PROTOCOLS</h1></Collapse.Title>
        <p>
        Below are the basic protocols used in all experiments during the development of the project.
        </p>
      </section>

      <Collapse>
        <Collapse.Title>Preparation of competent bacterial cells</Collapse.Title>
        <Collapse.Content>
          <iframe
            title="1"
            src="https://static.igem.wiki/teams/5058/preparation-of-competent-bacterial-cells-docx.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
              padding: "20",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
        Transformation of E. coli by heat shock
        </Collapse.Title>
        <Collapse.Content>
          <iframe
            title="2"
            src="https://static.igem.wiki/teams/5058/transformation-of-e-coli-by-heat-shock.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>Plasmid Miniprep Kit</Collapse.Title>
        <Collapse.Content>
          <iframe
            title="3"
            src="https://static.igem.wiki/teams/5058/purelink-quick-plasmid-miniprep-kit.pdf"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
        Yeast transformation
        </Collapse.Title>
        <Collapse.Content>
          <iframe
            src="https://static.igem.wiki/teams/5058/yeast-transformation.pdf"
            title="4"
            style={{
              width: "100%",
              height: "100%",
              minHeight: "500px",
              border: "none",
            }}
          />
        </Collapse.Content>
      </Collapse>

      <Collapse>
        <Collapse.Title>
        Cell Growth curve
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/cell-growth-curve-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Glucose Dosage
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/glucose-dosage-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Phosphate Quantification
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/phosphate-quantification.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Yeast biomass determination
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/yeast-biomass-determination.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Solid Cross-feeding
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/solid-cross-feeding.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Liquid cross feeding
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/liquid-cross-feeding-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Low phosphate cross-feeding assay
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/low-phosphate-cross-feeding-assay.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Bioreactor test
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/bioreactor-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Adapted B-Galactosidase assay
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/adapted-b-galactosidase-assay.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Inoculation of A.thaliana in medium conditioned with different precursors
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/inoculation-of-a-thaliana-in-medium-conditioned-with-different-precursors-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Sterilizing the Surface of Seeds by Chlorine Gas
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/sterilizing-the-surface-of-seeds-by-chlorine-gas-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        A.thaliana Col-o germination test under drought stress
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/a-thaliana-col-o-germination-test-under-drought-stress-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        A.thaliana Col-o germination test under salt stress
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/a-thaliana-col-o-germination-test-under-salt-stress-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>
      <Collapse>
        <Collapse.Title>
        Pot Experiment with Arabidopsis thaliana Col-0 + NR under Drought Stress
        </Collapse.Title>
        <Collapse.Content>
          <div className="w-full h-screen">
            <link rel="preload" href="" as="document" />

            <iframe
              src="https://static.igem.wiki/teams/5058/pot-experiment-with-arabidopsis-thaliana-col-0-nr-under-drought-stress-docx.pdf"
              title="5"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "500px",
                border: "none",
              }}
            />
          </div>
        </Collapse.Content>
      </Collapse>


      <p>
        <img
          className={"block mx-auto max-w-60"}
          src="https://static.igem.wiki/teams/5058/yob3-final-da-pg.svg"
          alt=""
        />
      </p>
    </main>
 </React.Fragment>
)
}
export default Protocols
